import React from 'react';
import classNames from 'classnames';
import ItemList from './item-list';
import { Teaser } from '../Teaser';
import Button from './button';
import Heading from './heading';

function mapSearchResultToTeaserItems(searchHits) {
  return searchHits.map(({ Heading, Image, Text, ...item }) => ({
    ...item,
    Title: Heading,
    Media: Image
      ? [{ ImageUrl: Image, BlockTypeName: 'ImageBlock' }]
      : undefined,
    Preamble: Text,
  }));
}
const SearchArticleList = (props) => {
  const {
    SearchResult: { SearchHits },
  } = props;
  const classnames = classNames({
    'c-search-list': true,
    'c-search-article-list': props.Appearance == 'article',
    'c-search-news-list': props.Appearance == 'news',
    'c-search-main-content': props.PropertyName == 'MainContent',
    'c-search-section-content': props.PropertyName == 'SectionContent',
    ...props.Modifiers,
  });

  if (!SearchHits || SearchHits.length === 0) return null;
  if (props.PropertyName == 'SectionContent') {
    return (
      <Teaser
        Items={mapSearchResultToTeaserItems(SearchHits)}
        SectionModifiers={{
          'c-section__heading--center': true,
          'c-search-list': true,
          'c-article-list__notext': props.HideDescriptions,
          'c-article-list__noimage': props.HideImages,
          [`c-search-list--${props.Appearance}`]: true,
        }}
        {...props}
      >
        <Button {...props} />
      </Teaser>
    );
  }
  return (
    <div className={classnames}>
      {props.Heading && (
        <Heading level={props.isH3 ? 3 : 2} className="c-search-list__heading">
          {props.Heading}
        </Heading>
      )}
      <ItemList {...props} />
    </div>
  );
};

export default SearchArticleList;
